// Externals
import React, { useState } from "react";
import { navigate, useBasePath } from "raviger";

// Components
import { Button } from "../components/Fields";

import InfoButton from "./InfoButton";

import Policy from "./Policy";
// Styles
import "./Above18.scss";
// import Policy from "./Policy";

const Above18 = (props) => {
	const basepath = useBasePath();

	const [isPopUpWindowOpen, setIsPopUpWindowOpen] = useState(false);

	const onToggle = () => {
		setIsPopUpWindowOpen((state) => !state);
	};

	return (
		props.showAbove18Window && (
			<div className="above18Window">
				<div className="wrapper">
					<h3>Under 18?</h3>
					<p>
						Our lovely dogs need to be adopted by people who are
						over 18. If you’re younger, you’ll need to have a
						guardian present before you start our survey.
					</p>
					<p>
						<br />
						<i style={{ fontSize: "0.8rem", lineHeight: "0.8rem" }}>
							The RSPCA is committed to handling your personal
							information in accordance with the Privacy Act 1988
							(Cth). You can read our Collection Notice
							<InfoButton
								open={isPopUpWindowOpen}
								// information={<Policy />}
								onToggle={onToggle}
								html={<Policy />}
								style={{ filter: "invert(1) brightness(10)" }}
							/>
						</i>
					</p>
					<Button
						label="Continue"
						onClick={() => navigate(basepath + "/questions/1")}
						data-cy="welcome-button"
					/>
				</div>
			</div>
		)
	);
};

export default Above18;
